import React from "react";
import { COMPANY, REFUND_POLICY } from "../data";
import { PageHero, useSeo } from "../ui";

/* 교환 · 환불 안내 — 문구는 data.js 의 REFUND_POLICY (이용약관 · 개인정보처리방침과 같은 모양) */
export default function Refund() {
  useSeo({
    title: "교환 · 환불 안내 | I.META 아이닷메타",
    description: "아이닷메타(I.META) 판매제품의 주문 취소 · 교환 · 반품 · 환불 안내입니다.",
    path: "/refund",
  });

  return (
    <>
      <PageHero
        kicker="REFUND"
        title="교환 · 환불 안내"
        desc={`${COMPANY.name}(${COMPANY.nameKo}) 판매제품의 주문 취소 · 교환 · 반품 · 환불 기준입니다.`}
      />

      <section className="section section--tight">
        <article className="legal">
          <p className="legal__date">시행일: {REFUND_POLICY.effective}</p>
          {REFUND_POLICY.sections.map((sec) => (
            <section key={sec.title} className="legal__section">
              <h2 className="legal__title">{sec.title}</h2>
              <ul className="legal__list">
                {sec.list.map((t) => <li key={t}>{t}</li>)}
              </ul>
            </section>
          ))}
        </article>
      </section>
    </>
  );
}
